/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { getDefaultState } from './util';

export default ({
  service = null,
  opts = {},
}) => ({
  namespaced: true,

  state: {
    ...getDefaultState(),
  },

  getters: {
    validSession: state => state.validSession,
    sessionData: state => state.sessionData,
    logoutUrl: state => state.logoutUrl,
    aviationDocuments: state => state.aviationDocuments,
  },

  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    setValidSession(state, valid) {
      state.validSession = valid;
    },
    setSessionData(state, sessionData) {
      state.sessionData = sessionData;
    },
    setLogoutUrl(state, logoutUrl) {
      state.logoutUrl = logoutUrl;
    },
    setAviationDocuments(state, aviationDocuments) {
      state.aviationDocuments = aviationDocuments;
    },
  },

  actions: {
    reset({ commit }) {
      commit('reset');
    },
    async initSessionValidity({ commit }) {
      try {
        const { data, status } = await service.get('sessionValid');
        if (data && status === 200) {
          commit('setValidSession', data.valid);
          commit('setSessionData', (data?.customerInfo || null));
        }
      } catch (e) {
        commit('setValidSession', getDefaultState().validSession);
        commit('setSessionData', getDefaultState().sessionData);
      }
    },
    async getLogin({ commit }, { serviceTicket, serviceUrl }) {
      const endpointPath = `login/?serviceTicket=${serviceTicket}&service=${encodeURIComponent(serviceUrl)}`;
      try {
        const { data, status } = await service.get(endpointPath);
        if (data && status === 200) {
          commit('setValidSession', true);
          commit('setSessionData', data);
        }
      } catch (e) {
        commit('setValidSession', getDefaultState().validSession);
        commit('setSessionData', getDefaultState().sessionData);
      }
    },
    async getLogout({ commit }) {
      const namespace = `${opts.bypassNamespace ? '' : `${opts.moduleNamespace}/`}`;
      commit(`${namespace}incrementApiCallsInProgress`, 'logout', { root: true });
      const endpointPath = `logout/?url=${encodeURIComponent(document.URL)}`;

      try {
        const { data: { logoutUrl } } = await service.get(endpointPath);
        commit('setValidSession', getDefaultState().validSession);
        commit('setSessionData', getDefaultState().sessionData);
        commit('setLogoutUrl', logoutUrl);
      } catch (e) {
        commit('setValidSession', getDefaultState().validSession);
        commit('setSessionData', getDefaultState().sessionData);
        commit('setLogoutUrl', null);
      } finally {
        commit(`${namespace}decrementApiCallsInProgress`, 'logout', { root: true });
      }
    },
    async getOtcDocuments({ commit }, params) {
      try {
        const { data } = await service.get(`otcDocuments/${params.customerGuid}/${params.identifier}/en_US`);
        commit('setAviationDocuments', data);
      } catch (e) {
        commit('setAviationDocuments', null);
      }
    },
    async getIscOtcDocuments({ commit }, params) {
      try {
        const { data } = await service.get(`iscOtcDocuments/${params.identifier}/en_US`);
        commit('setAviationDocuments', data);
      } catch (e) {
        commit('setAviationDocuments', null);
      }
    },
  },
});
